import React from 'react';

import FormOverlay from '../../../../components/FormOverlay';
import Table from "./components/Table";

import API from "../../../../services/API";

class History extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            history: []
        }
    }

    componentDidMount() {
        (async () => {
            const state = this.state;

            state.history = await API.DomainsV2.history(this.props.domain.id);

            this.setState(state);
        })()
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.close}>
                <div className={"form-overlay-body"} style={{ height: "600px", maxWidth: "70%", padding: '25px' }}>
                    <div>
                        <h3 style={{ margin: '0 0 25px 0', paddingBottom: '10px', borderBottom: '1px solid #eee' }}>{this.props.domain.domain}</h3>
                    </div>

                    <Table data={this.state.history} domain={this.props.domain} />
                </div>
            </FormOverlay>
        );
    }
}

export default History;



// WEBPACK FOOTER //
// ./src/scenes/DomainsV2/components/History/index.js